var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BaseModule, EventChannel } from '@syllepsis/adapter';
import debounce from 'lodash.debounce';
import { ToolbarLib } from '../..';
var DISABLE_CLASS = 'syl-toolbar-disable';
var ToolbarLoader = /** @class */ (function (_super) {
    __extends(ToolbarLoader, _super);
    function ToolbarLoader(adapter, originOption) {
        var _this = _super.call(this, adapter, Object.assign({}, originOption)) || this;
        // prefer disable state
        _this._isDisable = false;
        _this.traceEditable = debounce(function () {
            if (!_this._isDisable) {
                if (_this.adapter.editable) {
                    _this.$dom.classList.remove(DISABLE_CLASS);
                }
                else {
                    _this.$dom.classList.add(DISABLE_CLASS);
                }
            }
        }, 300);
        _this.disable = function () {
            _this.isDisable = true;
        };
        _this.enable = function () {
            _this.isDisable = false;
        };
        _this.render = function () {
            _this.bridge.setProps({
                editor: _this.adapter,
                option: _this.option,
                toolbarLib: new ToolbarLib({ editor: _this.adapter, option: _this.option }),
            });
        };
        var option = Object.assign({}, originOption);
        if (!option.mount) {
            var div = document.createElement('div');
            adapter.root.insertBefore(div, adapter.root.childNodes[0]);
            option.mount = div;
        }
        _this.$dom = option.mount;
        if (option.className)
            _this.$dom.classList.add(option.className);
        _this.bridge = new option.RenderBridge(adapter, option.Component, option.mount, 'toolbar');
        if (!adapter.editable) {
            _this.$dom.classList.add(DISABLE_CLASS);
        }
        adapter.addCommand('toolbar', {
            enable: _this.enable,
            disable: _this.disable,
            getEnable: function () { return !_this.$dom.classList.contains(DISABLE_CLASS); },
        });
        adapter.on(EventChannel.LocalEvent.ON_CHANGE, _this.traceEditable);
        adapter.on(EventChannel.LocalEvent.CONFIG_PLUGIN_CHANGE, _this.render);
        _this.render();
        return _this;
    }
    Object.defineProperty(ToolbarLoader.prototype, "isDisable", {
        get: function () {
            return this._isDisable;
        },
        set: function (val) {
            if (val === this._isDisable)
                return;
            this._isDisable = val;
            // disable when the editor is not editable
            if (!this.adapter.editable && !this._isDisable)
                return;
            if (this._isDisable) {
                this.$dom.classList.add(DISABLE_CLASS);
            }
            else {
                this.$dom.classList.remove(DISABLE_CLASS);
            }
        },
        enumerable: false,
        configurable: true
    });
    ToolbarLoader.prototype.setProps = function (option) {
        this.option = __assign(__assign({}, this.option), option);
        this.render();
    };
    ToolbarLoader.prototype.destructor = function () {
        if (this.option.mount)
            this.option.mount = null;
        this.adapter.off(EventChannel.LocalEvent.ON_CHANGE, this.traceEditable);
        this.adapter.off(EventChannel.LocalEvent.CONFIG_PLUGIN_CHANGE, this.render);
        this.bridge.unmount();
    };
    return ToolbarLoader;
}(BaseModule));
export { ToolbarLoader };
//# sourceMappingURL=index.js.map